import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import { API_GET_PACKAGE, API_UPDATE_PACKAGE, API_UPDATE_PACKAGE_PRODUCTS } from "../utils/apis";
import { API_STATE } from "../utils/constant";

// Asynchronous thunk for fetching resources by content type
export const fetchPackage = createAsyncThunk(
  "package/fetchPackage",
  async ({ packageId, language }) => {
    try {
      const response = await fetchWrapper.get(
        `${API_GET_PACKAGE}/${packageId}/${language}`
      );

      return response.resdata.contentData;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const updatePackage = createAsyncThunk(
  "package/updatePackage",
  async ({ uuid, language, payload }) => {
    try {
      const transformedPayload = {
        contentData: {
          menuName: payload.menuName || "",
          menuDescription: payload.menuDescription || "",
          titleName: payload.titleName || "",
          subtitleName: payload.subtitleName || "",
          titleDescription: payload.titleDescription || "",
          titleImageFileId: payload.titleImageFileId || null,
        }
      };

      const response = await fetchWrapper.put(
        `${API_UPDATE_PACKAGE}/${uuid}/${language}`,
        transformedPayload
      );
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const updatePackageProducts = createAsyncThunk(
  "package/updatePackageProducts",
  async ({ uuid, payload }) => {
    try {
      const response = await fetchWrapper.post(
        `${API_UPDATE_PACKAGE_PRODUCTS}/${uuid}/products`,
        payload
      );
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);


const initialPackage = {
  menuName: "",
  menuDescription: "",
  titleName: "",
  subtitleName: "",
  titleDescription: "",
  titleImageFileId: "",
  region: "SG",
  languages: [],
};

// Slice
const packageSlice = createSlice({
  name: "package",
  initialState: {
    data: null,
    status: API_STATE.IDLE,
    error: null,
  },
  reducers: {
    resetPackageValue: (state, action) => {
      const { payload } = action;
      state.data = { ...initialPackage, languages: [payload.language] };
      state.status = API_STATE.SUCCEEDED;
    },
    setValue: (state, action) => {
      const { payload } = action;
      state.data[payload.key] = payload.value;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.error = { ...payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetch package
      .addCase(fetchPackage.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(fetchPackage.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(fetchPackage.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      })

      // Handle update package
      .addCase(updatePackage.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(updatePackage.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(updatePackage.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      });
  },
});

//Action creators are generated for each case reducer function
export const {
  resetPackageValue,
  setValue,
  setError,
} = packageSlice.actions;

// Export the async action so it can be dispatched from components
export default packageSlice.reducer;
